// @flow

import md5                 from 'md5';
import type { CookieType } from '../../config/cookiesConfig';
import cookiesConfig       from '../../config/cookiesConfig';

type CookieTypeConfigHash = string

const getCookieTypeConfigHash = (cookieType: CookieType): CookieTypeConfigHash => {
  return md5(JSON.stringify(cookiesConfig[cookieType]));
};

export default getCookieTypeConfigHash;



// WEBPACK FOOTER //
// ./src/utils/cookieSettings/getCookieTypeConfigHash.js